var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"breakdownReport","title":"BreakDown Report","ok-only":true,"ok-title":"Close","lazy":true}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"width":"100","frameborder":"0","size":"lg"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1584cc6d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MbreakdownReport.vue
// module id = null
// module chunks = 